/* eslint-disable */
import axios from 'axios'

const CSRF_COOKIE_NAME = 'csrftoken'
const CSRF_HEADER_NAME = 'X-CSRFToken'

const session = axios.create({
  //xsrfCookieName: CSRF_COOKIE_NAME,
  //xsrfHeaderName: CSRF_HEADER_NAME,
  headers: {
    Authorization: 'Basic ZHJ1cGFsQG5hdmFuZHU6Z2l2ZW1lbXljb2ZmZWU=',
    //  'Content-Type': 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  }
})

export default session
